import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStickyNote } from "@fortawesome/free-regular-svg-icons";
import { faGear } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { Tooltip } from "react-tooltip";
import useAuth from "../hook/useAuth";

/**
 * LabelToggleRow (JS)
 * A row of non-exclusive, checkable buttons.
 * - props.options: string[] (button texts)
 * - props.selectedLabels: string[] (controlled selection from parent)
 * - props.setSelectedLabels: function(newSelected: string[] | updaterFn)
 * - props.label: string (left-side label text, defaults to "Filter by Labels")
 * - props.className: string (optional container classes)
 */
export const LabelToggleRow = ({
  options = [],
  selectedLabels = [],
  setSelectedLabels,
  label = "Filter by Labels",
  className = "",
  isDisabled = false,
}) => {
  if (typeof setSelectedLabels !== "function") {
    console.warn("LabelToggleRow requires setSelectedLabels prop (function)");
  }

  const isSelected = (text) => selectedLabels?.includes(text);

  const toggle = (text) => {
    if (!setSelectedLabels) return;
    setSelectedLabels((prev) => {
      const prevArr = Array.isArray(prev) ? prev : selectedLabels || [];
      return isSelected(text)
        ? prevArr.filter((t) => t !== text)
        : [...prevArr, text];
    });
  };

  return (
    <div className={`flex items-center gap-2 flex-wrap ${className}`}>
      <GoToLabelsButton />&nbsp;<span className="text-sm font-medium select-none fw-bold">{label}</span>
      
      <div className="mt-2 mb-2 flex items-center gap-2 flex-wrap">
        {/* <FontAwesomeIcon icon={faStickyNote} size='sm' />&nbsp; */}
        {options.length > 0 ? 
        options.map((text) => {
          const active = isSelected(text);
          return (
            <button
              key={text}
              type="primary"
              disabled={isDisabled}
              aria-pressed={active}
              onClick={() => toggle(text)}
              className={
                "btn-outline-primary px-3 py-1 rounded-2xl text-sm border " +
                (active
                  ? "bg-blue text-black border-gray font-semibold"
                  : "bg-transparent text-gray-800 border-gray-800")
              }
            >
              <span className="align-middle">{active ? /*"✓ "*/ "● " : "○ "}{text}</span>
            </button>
          );
        }) : <span>(No Labels)</span>}
      </div>
    </div>
  );
}

export const GoToLabelsButton = () => {
  const { auth } = useAuth()
  if (!auth?.IsRoot) return null;

return (
    <>
    <Link
    to="/setting?tab=case-labels"
    className="btn btn-sm btn-outline-secondary d-inline-flex align-items-center gap-2"
        id="case-labels-button"
    >
        <FontAwesomeIcon icon={faGear} 
    //     className="svg-inline--fa"
    // style={{ display: 'inline-block', fontSize: '1rem', lineHeight: 1 }}
        style={{ color: '#1f1f1fff' }}
        />
    </Link>
    <Tooltip anchorSelect="#case-labels-button" place="top">Manage Case Labels</Tooltip>
    </>
);
}
